import axios from "axios";
import jwtDecode from "jwt-decode";
import pDebounce from "p-debounce";
import localStorage from "src/utils/localStorage";
import {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  RENEW_WINDOW_TIME,
} from "src/variable/constant";

let accessToken = localStorage.getItem(ACCESS_TOKEN);

function shouldRefreshToken(token) {
  try {
    const decodedToken = jwtDecode(token);

    if (decodedToken.exp * 1000 - new Date().valueOf() < RENEW_WINDOW_TIME) {
      return true;
    }

    return false;
  } catch (ex) {
    return true;
  }
}

const refreshAccessToken = pDebounce.promise(
  async function () {
    const json = await axios.post(
      "/finan-user/api/v1/auth/renew-token",
      {
        refresh_token: localStorage.getItem(REFRESH_TOKEN),
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return json.data.data.token;
  },
  { maxAge: 60000 }
);

export async function getAccessToken() {
  if (!accessToken || shouldRefreshToken(accessToken)) {
    accessToken = await refreshAccessToken();
  }

  return accessToken;
}
